'use client';

import React, { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

const QuickContactBar: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  useEffect(() => {
    if (!isHydrated) return;

    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isHydrated]);

  const handleCall = () => {
    if (!isHydrated) return;
    window.location.href = 'tel:+918758758778';
  };

  const handleWhatsApp = () => {
    if (!isHydrated) return;
    window.open('https://wa.me/918758758778', '_blank');
  };

  const handleEmail = () => {
    if (!isHydrated) return;
    window.location.href = 'mailto:contact@sevasetutrust.org';
  };

  if (!isHydrated) {
    return (
      <div className="fixed bottom-6 right-6 z-40 flex flex-col space-y-3">
        <button className="w-14 h-14 rounded-full bg-primary text-primary-foreground shadow-elevated flex items-center justify-center">
          <Icon name="PhoneIcon" size={24} />
        </button>
      </div>
    );
  }

  return (
    <div
      className={`fixed bottom-6 right-6 z-40 flex flex-col space-y-3 transition-all duration-300 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
    >
      <button
        onClick={handleCall}
        className="w-14 h-14 rounded-full bg-primary text-primary-foreground shadow-elevated hover:shadow-cta hover:scale-110 transition-all duration-300 flex items-center justify-center"
        aria-label="Call us"
      >
        <Icon name="PhoneIcon" size={24} />
      </button>
      <button
        onClick={handleWhatsApp}
        className="w-14 h-14 rounded-full bg-secondary text-secondary-foreground shadow-elevated hover:shadow-cta hover:scale-110 transition-all duration-300 flex items-center justify-center"
        aria-label="WhatsApp us"
      >
        <Icon name="ChatBubbleLeftRightIcon" size={24} />
      </button>
      <button
        onClick={handleEmail}
        className="w-14 h-14 rounded-full bg-accent text-accent-foreground shadow-elevated hover:shadow-cta hover:scale-110 transition-all duration-300 flex items-center justify-center"
        aria-label="Email us"
      >
        <Icon name="EnvelopeIcon" size={24} />
      </button>
    </div>
  );
};

export default QuickContactBar;